var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCustomize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.034.947c-.65-.652-1.786-.652-2.438 0L8.814 6.73a.43.43 0 0 0-.114.2l-.609 2.437a.433.433 0 0 0 .418.536.42.42 0 0 0 .105-.013l2.438-.61a.426.426 0 0 0 .2-.113l5.782-5.782c.326-.326.505-.759.505-1.22 0-.46-.179-.892-.505-1.218zm-6.307 7.526l-1.625.407.406-1.626 4.784-4.783L15.51 3.69l-4.784 4.783zm5.698-5.698l-.305.304-1.219-1.219.305-.304a.883.883 0 0 1 1.219 0 .856.856 0 0 1 .252.61c0 .23-.09.446-.252.609z",
    fill: "#001247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.342 1.125a8.095 8.095 0 1 0 5.708 6.27",
    stroke: "#001247",
    strokeWidth: 1.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomize);
export default __webpack_public_path__ + "static/media/icon-customize.cc5bcd45.svg";
export { ForwardRef as ReactComponent };